import React, { Component } from 'react'
import { apiProcess } from '../../../api/api.js'
import { Button } from 'components/elements'
import * as Yup from 'yup'
import './insuranceScreen.css'

import {
  isUserInternational,
  fullStateFromShortCode,
  fullCountryFromShortCode,
} from '../../../utils'
import { Formik, Form } from 'formik'
import {
  addressInitialValues,
  addressFieldProps,
} from '../../profile/defaultAddressBlockValues'

import AddressInputBlock from '../../profile/addressFields'
import { PROFILE_ADDRESS } from '../main/constants.js'

const domesticValidation = Yup.object().shape({
  address_line_1: Yup.string()
    .nullable()
    .required('Address Line 1 required.'),
  //address_line_2 : Yup.string().required('Required'),
  address_city: Yup.string()
    .nullable()
    .required('City is required.'),
  address_region: Yup.string()
    .nullable()
    .required('State/Region is required.'),
  address_country: Yup.string()
    .nullable()
    .required('Country is required.'),
  address_postal_code: Yup.number()
    .typeError('Postal Code is required.')
    .required('Postal Code is required.'),
})

const internationalValidation = Yup.object().shape({
  address_line_1: Yup.string()
    .nullable()
    .required('Address Line 1 is required.'),
  //address_line_2 : Yup.string().required('Required'),
  address_city: Yup.string()
    .nullable()
    .required('City is required.'),
  address_region: Yup.string()
    .nullable()
    .required('Region is required.'),
  address_country: Yup.string()
    .nullable()
    .required('Country is required.'),
  //address_postal_code : Yup.number().required('Required'),
})

class ProfileAddressSreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      generalError: false,
    }
  }

  validateAddressEdits = (values, actions) => {
    let valuesToCheck = {
      address_line_1: values.address_line_1,
      //address_line_2 : Yup.string().required('Required'),
      address_city: values.address_city,
      address_region: values.address_region,
      address_country: values.address_country,
      address_postal_code: values.address_postal_code,
    }

    let documentSchema = domesticValidation

    if (isUserInternational(values.address_country, values.address_region)) {
      documentSchema = internationalValidation
    }

    documentSchema
      .validate(valuesToCheck, { abortEarly: false })
      .then((valid) => {
        this.finalizeEdits(values, actions)
        actions.setSubmitting(false)
      })
      .catch((responseData) => {
        //console.log(responseData)
        actions.setSubmitting(false)
        for (let i = 0; i < responseData.inner.length; i++) {
          actions.setFieldError(
            responseData.inner[i]['path'],
            responseData.inner[i]['message']
          )
          //setFieldError(responseData.inner[i]['path'], responseData.inner[i]['message'])
        }
      })
  }

  componentDidMount() {
    this.props.onScreenLoad(PROFILE_ADDRESS)
  }

  finalizeEdits = (values, actions) => {
    let addressCountryFull = fullCountryFromShortCode(values.address_country)
    let addressStateFull = fullStateFromShortCode(
      values.address_country,
      values.address_region
    )

    let apiURL = 'users/basic_info'
    let profileData = {
      contact: {
        location: {
          //address_note : '',
          address_street_1: values.address_line_1,
          address_street_2: values.address_line_2,
          //address_street_3 : '',
          address_city: values.address_city,
          address_state: addressStateFull,
          address_state_abbreviation: values.address_region,
          address_zip: values.address_postal_code,
          address_country: addressCountryFull,
        },
      },
    }

    apiProcess(
      apiURL,
      profileData,
      'update-profile',
      'Update Profile Address from Information Wizard'
    )
      .then(
        function(responseData) {
          //show success banner.
          //clear all errors form. that includes birthdays
          this.setState({
            generalError: false,
          })
          this.props.onSuccess()
          actions.setSubmitting(false)
        }.bind(this)
      )
      .catch(
        function(responseData) {
          //show failure banner.
          this.setState({
            generalError: true,
          })
          //alert('CHANGE WHEN API IS UP')
          //this.props.onSuccess()
          actions.setSubmitting(false)
          //If there are errors to parse out, we will do them here.
          //for now just do a banner error right here.
        }.bind(this)
      )
  }

  render() {
    const { passedAddress } = this.props

    return (
      <React.Fragment>
        <Formik
          initialValues={addressInitialValues(passedAddress)} //this.state.data.drivers_license)}
          //validationSchema={documentSchema}
          onSubmit={(values, actions) =>
            this.validateAddressEdits(values, actions)
          }
          render={({
            errors,
            touched,
            setFieldValue,
            isSubmitting,
            values,
            actions,
          }) => (
            <Form>
              <React.Fragment>
                <h2 className="title is-size-4 has-text-weight-bold">
                  Personal Address
                </h2>
                {this.state.generalError && (
                  <div className="has-text-danger">
                    Sorry we are having issues right now. Please try again.
                  </div>
                )}
                <AddressInputBlock
                  onChange={setFieldValue}
                  addressData={{
                    address_line_1: values.address_line_1,
                    address_line_2: values.address_line_2,
                    address_city: values.address_city,
                    address_region: values.address_region,
                    address_country: values.address_country,
                    address_postal_code: values.address_postal_code,
                  }}
                  //locked={locked}
                  errors={errors}
                />
                <Button
                  color="primary"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  size="medium"
                  type="submit"
                >
                  Update Address
                </Button>
              </React.Fragment>

              {this.props.skippable && (
                <div className="mt-2">
                  <span
                    className="micro-action finger-pointer"
                    onClick={() => this.props.onSuccess()}
                  >
                    I'll do this later
                  </span>
                </div>
              )}
            </Form>
          )}
        />
      </React.Fragment>
    )
  }
}
export default ProfileAddressSreen

ProfileAddressSreen.defaultProps = {
  onSuccess: function() {},
  skippable: true,
  passedAddress: addressFieldProps,
  onScreenLoad: function() {},
}
